import { Component, OnInit, Inject, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ConstantsService } from "../services/constants.service";
@Component({
  selector: 'app-home-popup',
  templateUrl: './home-popup.component.html',
  styleUrls: ['./home-popup.component.scss']
})
export class HomePopupComponent implements OnInit {
  public isLogin = false;
  @Input() title: any;
  @Input() description: any;
  @Output() onCloseClick: EventEmitter<string> = new EventEmitter();
  private dialog = null;
  constructor(@Inject(DOCUMENT)
  public constants: ConstantsService,
  ) { }
  ngOnInit() {
  }
  close() {
    this.dialog.close();
    this.onCloseClick.emit('true')
  }

}
